/**
 * Warble starting patches — the five MOTIFS that are pure parameter STATES,
 * values verbatim from Chirp/warble.html:648-658 at 6f4d80a.
 *
 * The motif list also contains time-varying recipes (slowmod/fastmod's FM
 * vibrato, the trill family's envelope timer, sweep's β ramp). Those are not
 * patches — they are performances — and they arrive with the deferred
 * vibrato/trill work, not here.
 */

export interface WarblePatch {
  id: string;
  label: string;
  /** Baseline β when the pitch hand is absent (pad play); hands override it. */
  beta: number;
  /** Suggested α ceiling — the hand still sweeps AMIN..AMAX; kept for tests. */
  alpha: number;
  fold: number;
  refl: number;
  /** Two-voice detune between the syrinx's two sides. */
  spread: number;
  grit: number;
  hint: string;
}

const base = { fold: 0, refl: 0.1, spread: 0, grit: 0 };

export const WARBLE_PATCHES: WarblePatch[] = [
  { id: 'flat', label: 'FLAT', ...base, beta: 1.0, alpha: 0.2,
    hint: 'One tone, no motion — the model at rest.' },
  { id: 'stack', label: 'STACK', ...base, beta: 0.012, alpha: 0.22,
    hint: 'Drop the tension and the cycle goes sawtooth — twenty partials, one source.' },
  { id: 'rough', label: 'ROUGH', ...base, beta: 0.9, alpha: 0.3, fold: 2.4, refl: -0.9,
    hint: 'Fold the cycle against its own echo — the pitch halves and roughens.' },
  { id: 'twovox', label: 'TWO VOX', ...base, beta: 0.95, alpha: 0.22, spread: 0.14,
    hint: 'Both sides of the syrinx at once, slightly apart — one throat, two birds.' },
  { id: 'churr', label: 'CHURR', ...base, beta: 0.08, alpha: 0.26, grit: 0.55,
    hint: 'Jitter on the tension — added noise, honestly labelled. Not emergent.' },
];

export const DEFAULT_GAMMA = 24000;
